import React, { useContext } from 'react'
import { Container } from 'react-bootstrap'

import tf21_error_404 from 'img/tf21-error-404.png'

import { checkIsMobile } from 'shared/index'
import AuthContext from 'shared/contexts/auth'

function NotFound() {
	const isMobile = checkIsMobile()
	const { isAuthenticated } = useContext(AuthContext)
	return (
		<>
			{isAuthenticated && (
				<div style={{ height: isMobile ? '20vh' : '12vh' }}></div>
			)}
			<Container
				style={{
					position: 'relative',
					paddingBottom: isAuthenticated ? '350px' : '',
				}}>
				<img
					style={{ display: 'block' }}
					src={tf21_error_404}
					className="img-fluid mx-auto pt-4"
					alt="404 Not Found"></img>
			</Container>
		</>
	)
}

export default NotFound
